import { Admin } from '@/pages/Admin';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_admin/admin/')({
  component: Admin,
});


